import StarterKit from "@tiptap/starter-kit";

// Tiptap extensions for the position description editor, kept in one place so
// the round-trip test (descriptionEditor.roundtrip.test.ts) exercises exactly
// what RichTextEditor renders. The vocabulary matches the server's sanitizer
// (paragraphs, bold, italic, bullet/numbered lists, links), so what the editor
// emits survives the write byte-for-byte.
export const descriptionEditorExtensions = [
  StarterKit.configure({
    blockquote: false,
    code: false,
    codeBlock: false,
    heading: false,
    horizontalRule: false,
    // Links: created by typing/pasting URLs (autolink) and by pasting linked
    // content — no "add link" prompt. The editor emits exactly the shape the
    // server keeps (target=_blank, rel="noopener noreferrer"; the extension's
    // default rel adds a "nofollow" the server would strip). https and mailto
    // only, matching the sanitizer, so the editor never makes a link that would
    // silently vanish on save.
    link: {
      autolink: true,
      linkOnPaste: true,
      openOnClick: false,
      // Bare domains ("queen.one") autolink as https, not the http default the
      // server would reject.
      defaultProtocol: "https",
      HTMLAttributes: { target: "_blank", rel: "noopener noreferrer" },
      isAllowedUri: (url, ctx) => {
        const scheme = url.match(/^([a-z][a-z0-9+.-]*):/i)?.[1]?.toLowerCase();
        if (scheme && scheme !== "https" && scheme !== "mailto") {
          return false;
        }
        return ctx.defaultValidate(url);
      }
    },
    strike: false,
    underline: false,
    // No trailing empty paragraph after a final list — it would be stored (the
    // sanitizer keeps <p></p>) and render as a blank line.
    trailingNode: false
  })
];
